module.exports = __webpack_public_path__ + "img/peiicon1.8eee1ffa.svg";